/**
 * Copyright (C) Sitevision 2002-2023, all rights reserved
 */
import { hasPortlet } from '../../util/findPortlets.js';

if (hasPortlet('sv-sharepointfile-portlet')) {
  import(/* webpackChunkName: "sharepointfile-portlet" */ './index.js');
}
